import { css } from 'styled-components'

export const texts = (themeColors) => ({
  texts: {
    plain: css`
      color: ${themeColors.secondary};
    `,
  },
})
